import React, { Component } from "react"
import "./Pulses.scss"

class Pulses extends Component {
    constructor() {
        super();
    }
    componentDidMount() {
        const _pulses = ["power", "play", "green"]
    }
    render() {
        return (
            <div className="pulses">
            <div className="pulse power"></div>
                <div className="pulse play"></div>
                <div className="pulse green"></div>
            </div>
        )
    }
}

export default Pulses;


// WEBPACK FOOTER //
// ./src/Components/Remote/Pulses.jsx